import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PropertyOwnerRequestBody, PropertyOwnerResponse } from "./types";

export class PropertyOwnerAPI extends BaseAPI<
    PropertyOwnerRequestBody,
    PropertyOwnerResponse
> {
    protected route = ApiRoutes.property.owner;
    protected method = RequestMethod.GET;
}
